import Vue from 'vue';
import Vuex from 'vuex';
import VueCookies from 'vue-cookies';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    isxcx:false,
    code: null,
    // user_key: process.env.NODE_ENV === 'development' ? 'o3mfN0cLHI4GqCR3BCOshra7kY4A' : null, //定制开发李巧凤
    // user_key: process.env.NODE_ENV === 'development' ? 'o3mfN0XpRcgk6vcbrEdrLXeUQb8M' : null, //故事很短.
    // user_key:process.env.NODE_ENV === 'development' ? 'o3mfN0Sj3fDKRR8HFi_IMr4OMZxw' :null,
    // user_key:localStorage.getItem('token')?localStorage.getItem('token'):null,
    // user_key:'o3mfN0de-wqe793Up_WM74Z4o0eU',
    // user_key:'o3mfN0dWHY6O7Z-0LO0-KK9ApHYg',
    user_key:null,
    access_token:VueCookies.get('token')?VueCookies.get('token'):null,
    tempat:null,
    user_info: {},
    testStatus: {
      data:{
        know:{
          zq:0,
          cw:0,
          tested:false
        },
        speak:{
          zq:0,
          cw:0,
          tested:false
        },
        vocabulary:{
          zq:0,
          cw:0,
          tested:false
        },
        sight:{
          zq:0,
          cw:0,
          tested:false
        },
        read:{
          zq:0,
          cw:0,
          tested:false
        },
        put:{
          zq:0,
          cw:0,
          tested:false
        },
        missing:{
          zq:0,
          cw:0,
          tested:false
        }
      },
      passed:0      //0:测试未完成,1:测试不通过需要降级,2:测试通过升级
    },
    testLevel:0,       //测试等级0:字母级;1:pre-reading;2:emergent;3:early1;4:early2;5:early3;6:early4;7:fluency;
    tixing:{
      'lv0':['know','speak','vocabulary'],
      'lv1':['know','speak','vocabulary'],
      'lv2':['vocabulary','sight','read'],
      'lv3':['vocabulary','sight','read'],
      'lv4':['vocabulary','sight','read'],
      'lv5':['vocabulary','sight','put'],
      'lv6':['vocabulary','sight','missing']
    },
    title:{
      'lv0':['I know It','I Can Speak','My Vocabulary'],
      'lv1':['I know It','I Can Speak','My Vocabulary'],
      'lv2':['I know It','Sight Words','I can Read'],
      'lv3':['I know It','Sight Words','I can Read'],
      'lv4':['I know It','Sight Words','I can Read'],
      'lv5':['I know It','Sight Words','Put it in Order'],
      'lv6':['I know It','Sight Words','What Is Missing']
    },
    maxerror:{
      put:3,
      know:5,
      speak:5,
      vocabulary:5,
      sight:5,
      read:5,
      missing:5
    }
  },
  mutations: {
    setCode(state, data) {
      state.code = data;
    },
    setUserKey(state, key) {
      state.access_token = key;
    },
    setTempat(state, key) {
      state.tempat = key;
    },
    setUserInfo(state, userinfo) {
      state.user_info = Object.assign(state.user_info, userinfo);
      // state.user_info.phone='';
    },
    setTestStatus(state, payload) {
      state.testStatus.data[payload.name] = payload.value;
    },
    reset(state) {
      state.testStatus = {
        data:{
          know:{
            zq:0,
            cw:0,
            tested:false
          },
          speak:{
            zq:0,
            cw:0,
            tested:false
          },
          vocabulary:{
            zq:0,
            cw:0,
            tested:false
          },
          sight:{
            zq:0,
            cw:0,
            tested:false
          },
          read:{
            zq:0,
            cw:0,
            tested:false
          },
          put:{
            zq:0,
            cw:0,
            tested:false
          },
          missing:{
            zq:0,
            cw:0,
            tested:false
          }
        },
        passed:0      //0:测试未完成,1:测试不通过需要降级,2:测试通过升级
      }
    },
    setPassed(state,status){
      state.testStatus.passed=status;
    },
    setLevel(state,payload){
      state.testLevel=payload;
    },
    setAccessToken(state,token){
      state.access_token=token;
    },
    setIsXcx(state,param){
      state.isxcx=param;
    }
  },
  actions: {
    changeCode({commit}, code) {
      commit('setCode', code);
      return Vue.axios.post('/Xcx/Login/index', {code: code}).then((res) => {
        console.warn('登录凭证:'+res.data.data.access_token);
        if (res.data.status) {
          // localStorage.setItem('token',res.data.data.user_key);
          // commit('setUserKey', res.data.data.access_token);
          commit('setTempat',res.data.data.access_token);
          return Promise.resolve(res.data.data.access_token);
        }
      });
    },
    changeUserInfo({commit}, info) {
      commit('setUserInfo', info);
      if(info.access_token){
        commit('setAccessToken',info.access_token);
      }
      
      return Promise.resolve('success');
    },
    changeTestStatus({commit}, payload) {
      commit('setTestStatus', payload);
      var passed=0;
      var data=this.state.tixing['lv'+this.state.testLevel];
      for(var key in data){
        if(this.state.testStatus.data[data[key]].cw>=this.state.maxerror[data[key]]){
          commit('setPassed',1);
          break;
        }else if(this.state.testStatus.data[data[key]].tested){
          commit('setPassed',0);
        }
        if(this.state.testStatus.data[data[key]].tested&&this.state.testStatus.data[data[key]].cw<this.state.maxerror[data[key]]){
          passed++;
        }
        if(passed>=3){
          commit('setPassed',2);
        }
      }

      return Promise.resolve('success');
    },
    changeTestLevel({commit},payload){
      commit('setLevel',payload);
    },
    logout({commit}){
      commit('setUserKey',null);
      VueCookies.remove('token');
    },
    changeIsXcx({commit},payload){
      commit('setIsXcx',payload);
    }
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/store.js